export function isStringArrayIncludes(stringArray, matchedArray) {

  for (let string of matchedArray) {

    if (stringArray.indexOf(string) === -1) {
      return false;
    }

  }

  return true;

};

export function distinct(stringArray) {

  let distinctValues = [];

  const distinctCache = {};

  for (let value of stringArray) {

    if (distinctCache[value] !== void 0) {
      continue;
    }

    distinctCache[value] = 1;
    distinctValues.push(value);

  }

  return distinctValues;

}

export function excludeIndex(array, excludedIndex) {

  const results = [];
  const arrayLength = array.length;

  for (let index = 0; index < arrayLength; index++) {

    if (index === excludedIndex) {
      continue;
    }

    results.push(array[index]);

  }

  return results;

}

export function hasSameContents(stringArrayA, stringArrayB) {

  if (stringArrayA.length !== stringArrayB.length) {
    return false;
  }

  stringArrayA.sort();
  stringArrayB.sort();

  const stringArrayALength = stringArrayA.length;

  for (let index = 0; index < stringArrayALength; index++) {

    if (stringArrayA[index] !== stringArrayB[index]) {
      return false;
    }

  }

  return true;

}

export function flatten(arrayOfArrays) {

  const array = [];

  for (let _array of arrayOfArrays) {
    array.push(..._array);
  }

  return array;

}